import { FunctionComponent } from 'react';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import classnames from 'classnames';

import { Routes } from 'types/routes';

import BreadCrumbs from 'components/layout/BreadCrumbs/component';
import Button from 'components/layout/Button';
import { ButtonStyles, ButtonVariants } from 'components/layout/Button/types';
import LayoutContainer from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PagePolicyPrivacySectionContent: FunctionComponent<Props> = ({ translations }) => {
    const router = useRouter();
    const { publicRuntimeConfig } = getConfig();

    const privacyPolicyPartner = router.query.privacyPolicy === 'partner';

    return (
        <StyledComponent className="page-policy-privay-section-content">
            <LayoutContainer className="policy-privacy">
                <BreadCrumbs
                    elements={[{
                        key: 'home',
                        href: { pathname: Routes.PublicHome },
                        label: translations?.breadCrumbsHome,
                        active: false,
                        disableDivider: true,
                    }, {
                        key: 'regulations',
                        href: { pathname: Routes.PublicPolicyPrivacy },
                        label: translations?.breadCrumbsPolicyPrivacy,
                        active: true,
                        disableDivider: false,
                    }]}
                />
                <section className="policy-privacy-data">
                    <div className="policy-privacy-top-bar">
                        <div
                            className={classnames({
                                'policy-privacy-top-bar__users': true,
                                'active': !privacyPolicyPartner,
                            })}
                            onClick={() => router.push({
                                pathname: router.pathname,
                                query: { privacyPolicy: 'user' },
                            }, undefined, { shallow: true })}
                        >
                            {translations?.usersButton}
                        </div>
                        <div
                            className={classnames({
                                'policy-privacy-top-bar__partners': true,
                                'active': privacyPolicyPartner,
                            })}
                            onClick={() => router.push({
                                pathname: router.pathname,
                                query: { privacyPolicy: 'partner' },
                            }, undefined, { shallow: true })}
                        >
                            {translations?.partnersButton}
                        </div>
                    </div>
                    <header className="policy-privacy-header">
                        <h1 className="policy-privacy-header-headline">
                            {translations?.headline}
                        </h1>
                        <Button
                            className="policy-privacy-header-button desktop"
                            style={ButtonStyles.TextCTA}
                            onClick={() => {
                                if (privacyPolicyPartner) {
                                    return router.push(Routes.PublicPdfPolicyPrivacy);
                                }

                                return router.push(Routes.PublicPdfPolicyPrivacyUsers);
                            }}
                        >
                            {translations?.downloadButton}
                        </Button>
                        <Button
                            className="gradient-180 mobile"
                            style={ButtonStyles.Primary}
                            variant={ButtonVariants.Primary}
                            onClick={() => {
                                if (privacyPolicyPartner) {
                                    return window.open(`https://docs.google.com/gview?embedded=true&url=${publicRuntimeConfig.APP_URL + Routes.PublicPdfPolicyPrivacy}`, '_blank');
                                }

                                return window.open(`https://docs.google.com/gview?embedded=true&url=${publicRuntimeConfig.APP_URL + Routes.PublicPdfPolicyPrivacyUsers}`, '_blank');
                            }}
                        >
                            {privacyPolicyPartner
                                ? translations?.previewAndDownloadButtonPartners
                                : translations?.previewAndDownloadButtonUsers
                            }
                        </Button>
                    </header>
                    <div className="policy-private-content-container">
                        {privacyPolicyPartner && (
                            <iframe
                                title="privacy policy partners"
                                width="100%"
                                height="100%"
                                src={`${Routes.PublicPdfPolicyPrivacy}#zoom=100&toolbar=0&view=FitH`}
                            />
                        )}
                        {!privacyPolicyPartner && (
                            <iframe
                                title="privacy policy users"
                                width="100%"
                                height="100%"
                                src={`${Routes.PublicPdfPolicyPrivacyUsers}#zoom=100&toolbar=0&view=FitH`}
                            />
                        )}
                    </div>
                </section>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PagePolicyPrivacySectionContent;
